import React, { Component } from 'react';
import PropTypes from 'prop-types';

import { connect } from 'react-redux';
import {
  getShopifyStoreInfo,
  clearShopifyStoreInfo,
  clearDisconnectShopifyStore,
  clearConnectShopifyStore,
} from 'redux/integrations/actions';

import { Loader } from 'semantic-ui-react';

import ProSectionPlaceholder
  from 'components/common/pro-placeholders/ProSectionPlaceholder';
import ShopifyConnectStoreForm
  from 'components/dashboard/integrations/shopify/ShopifyConnectStoreForm';
import ShopifyStoreInfo
  from 'components/dashboard/integrations/shopify/ShopifyStoreInfo';
import CommonMessage from 'components/common/CommonMessage';

import './ShopifyIntegrationContent.css';


class ShopifyIntegrationContent extends Component {
  static propTypes = {
    getShopifyStoreInfo: PropTypes.func.isRequired,
    clearShopifyStoreInfo: PropTypes.func.isRequired,
    clearConnectShopifyStore: PropTypes.func.isRequired,
    me: PropTypes.object,
    shopifyStoreInfo: PropTypes.object,
    shopifyStoreInfoError: PropTypes.object,
    disconnectShopifyStoreSuccess: PropTypes.object,
    connectShopifyStoreSuccess: PropTypes.object,
    connectShopifyStoreError: PropTypes.object,
  };

  static defaultProps = {
    me: null,
    shopifyStoreInfo: null,
    shopifyStoreInfoError: null,
    disconnectShopifyStoreSuccess: null,
    connectShopifyStoreSuccess: null,
    connectShopifyStoreError: null,
  };

  constructor(props) {
    super(props);
    this.intervalRefetch = null;
  }

  componentDidMount() {
    this.props.getShopifyStoreInfo();
    this.intervalRefetch = setInterval(() => {
      this.props.getShopifyStoreInfo();
    }, 2000);
  }

  componentDidUpdate(prevProps) {
    // Clear refecth when Error
    if (this.props.shopifyStoreInfoError) {
      clearInterval(this.intervalRefetch);
    }

    // Clear refecth when shopifyStoreInfo is received
    if (
      this.props.shopifyStoreInfo &&
      !this.props.shopifyStoreInfo.sync_products_in_progress
    ) {
      clearInterval(this.intervalRefetch);
    }

    // Resync Shopify products
    if (prevProps.shopifyStoreInfo && !this.props.shopifyStoreInfo) {
      this.intervalRefetch = setInterval(() => {
        this.props.getShopifyStoreInfo();
      }, 2000);
    }

    // Refech Shopify info when disconnect
    if (!prevProps.disconnectShopifyStoreSuccess && this.props.disconnectShopifyStoreSuccess) {
      this.props.getShopifyStoreInfo();
      this.props.clearDisconnectShopifyStore();
      this.props.clearConnectShopifyStore();
    }
  }

  componentWillUnmount() {
    this.props.clearShopifyStoreInfo();
    this.props.clearConnectShopifyStore();
    clearInterval(this.intervalRefetch);
  }

  render() {
    const {
      me,
      shopifyStoreInfo,
      shopifyStoreInfoError,
      connectShopifyStoreError,
    } = this.props;

    const loader = !shopifyStoreInfo && !shopifyStoreInfoError &&
      <Loader active inline="centered" />;
    const storeInfo = shopifyStoreInfo &&
      !shopifyStoreInfo.not_connected && <ShopifyStoreInfo />;
    const connectionForm = shopifyStoreInfo &&
      shopifyStoreInfo.not_connected && <ShopifyConnectStoreForm />;
    const connectionError = connectShopifyStoreError && (
      <CommonMessage error>
        Shopify Server connection was failed. Try again later.
      </CommonMessage>
    );

    return (
      <ProSectionPlaceholder
        key="shopify-integration-pro-feature-key"
        className="shopify-integration-content__component"
        // locked={me && me.subscription && !me.subscription.ff_shopify_integration}
        locked={false}
        text={
          <>
            Shopify integration is available on the <strong>PRO</strong> plan. Check it
          </>
        }
      >
        {loader}
        {connectionForm}
        {storeInfo}
        {connectionError}
      </ProSectionPlaceholder>
    );
  }
}

const mapStateToProps = state => (
  {
    me: state.usersReducer.me,
    shopifyStoreInfo: state.integrationsReducer.shopifyStoreInfo,
    shopifyStoreInfoError: state.integrationsReducer.shopifyStoreInfoError,
    connectShopifyStoreSuccess: state.integrationsReducer.connectShopifyStoreSuccess,
    connectShopifyStoreError: state.integrationsReducer.connectShopifyStoreError,
    disconnectShopifyStoreSuccess: state.integrationsReducer.disconnectShopifyStoreSuccess,
  }
);

export default connect(
  mapStateToProps,
  {
    getShopifyStoreInfo,
    clearShopifyStoreInfo,
    clearDisconnectShopifyStore,
    clearConnectShopifyStore,
  },
)(ShopifyIntegrationContent);
